import { render, staticRenderFns } from "./TopBalance.vue?vue&type=template&id=394dab04&scoped=true"
import script from "./TopBalance.vue?vue&type=script&lang=js"
export * from "./TopBalance.vue?vue&type=script&lang=js"
import style0 from "./TopBalance.vue?vue&type=style&index=0&id=394dab04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394dab04",
  null
  
)

export default component.exports